<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="500">
    <v-card>
      <v-form>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t(`profile.mentorship.changeTag.title`) }}
        </v-card-title>

        <v-card-text>
          <v-row no-gutters class="my-4">
            <template v-for="tag in suitableEmployeeTags">
              <v-chip
                small
                class="mr-2"
                :key="tag.id"
                @click="selected = tag"
                :style="
                  tag.source == 'kronos' ? 'text-decoration: underline;' : ''
                "
                >{{ tag.description || tag.name }}
              </v-chip>
            </template>
            <template v-if="!suitableEmployeeTags.length">
              <span>
                No suitable work zones. Work zone cant have ongoing mentorship.
              </span>
            </template>
          </v-row>
          <v-row
            v-if="oldTag"
            no-gutters
            class="my-2"
            align="center"
            justify="center"
          >
            <v-chip>{{ oldTag.description || oldTag.name }}</v-chip> ->
            <v-chip>{{
              selected && (selected.description || selected.name)
            }}</v-chip>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" text @click="hide">
            {{ $t("dialog.cancel") }}
          </v-btn>

          <v-btn
            :disabled="!selected"
            @click="save"
            color="primary"
            text
            :loading="loading"
            >{{ $t("dialog.change") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import EmployeeTags from "@/components/employee/EmployeeTags";

export default {
  props: ["oldTag", "show", "loading", "employee"],
  components: { EmployeeTags },
  data() {
    return {
      employees: [],
      selected: null,
    };
  },
  watch: {
    show() {
      if (!this.show) {
        this.selected = null;
      }
    },
  },
  computed: {
    suitableEmployeeTags() {
      return (
        (this.oldTag &&
          this.employee.tags &&
          this.employee.tags.length &&
          this.employee.tags.filter((x) => {
            const tagHasMentorships = this.employee.mentorships.some(
              (mentorship) => mentorship.tag && mentorship.tag.id === x.id
            );
            return x.id !== this.oldTag.id && !tagHasMentorships;
          })) ||
        []
      );
    },
  },
  methods: {
    tagClicked(tag) {
      if (!tag || !tag.id) return;
      this.selected = tag;
    },
    hide() {
      this.$emit("update:loading", false);
      this.$emit("update:show", false);
    },
    save() {
      this.$emit("update:loading", true);
      this.$emit("change", this.selected.id);
    },
  },
};
</script>
